<template>
    <section class="extract-view">
        <div class="extract-container">
            <div class="actions">
                <div class="period" @click="changePeriodSelectionMenuVisibility">
                    <h1>Período</h1>
                    <i class="fa fa-sort-down icon"></i>
                </div>
                <!-- <div class="export" @click="openExportModal"> -->
                <div class="export" @click="generatePDFExport">
                    <i class="fa fa-download icon"></i>
                </div>
            </div>
            <div id="allExtractData" v-if="Object.values(getExtrato).length > 0">
                <div class="list" v-for="(extrato, exKey) in getExtrato" :key="exKey">
                    <h2 class="title" v-text="exKey"></h2>
                    <div class="list-fields">
                        <div v-for="(field, fieldKey) in fields" :key="fieldKey" class="list-field">
                            <h1 v-text="field"></h1>
                        </div>
                    </div>
                    <div class="list-item" v-for="(excItem, excItemKey) in extrato" :key="exKey+excItemKey">
                        <div class="list-item-field">
                            <span class="schoolName" v-text="excItem.label"></span>
                        </div>
                        <div class="list-item-field">
                            <span class="tValue" v-if="excItem.value" v-text="formatValue(excItem.value)" :class="{ negative: excItem.value < 0, positive: excItem.value > 0 }"></span>
                        </div>
                        <div class="list-item-field">
                            <span class="tBalance" v-text="formatValue(excItem.balance)"></span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <h1 class="not-found">Não foram encontrados resultados</h1>
            </div>
        </div>
        <PeriodSelectionComponent @changePeriod="changePeriod" :periodRaw="getSummaryDate" />
        <!-- <ModalInfo @actionTrue="confirmExport" @actionFalse="closeModalInfo"/> -->
    </section>
</template>

<script>
import PeriodSelectionComponent from '@/components/bottom-popups/PeriodSelectionComponent.vue'
// import ModalInfo from '@/components/modals/ModalInfo.vue'
import { mapActions, mapGetters } from 'vuex'
import { pdfExport } from '@/libs/Util.js'

export default {
    name: 'ExtractComponent',
    components: {
        PeriodSelectionComponent
        // , ModalInfo
    },
    data () {
        return {
            fields: ['Transação', 'Valor', 'Saldo'],
            searchText: '',
            filteredList: []
        }
    },
    computed: {
        ...mapGetters(['getExtrato', 'getSummaryDate'])
    },
    methods: {
        ...mapActions(['changePeriodSelectionMenuVisibility', 'showModalInfo', 'closeModalInfo']),
        formatValue (value) {
            if (!value) {
                return '0.0'.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            }
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        },
        changePeriod: function (period) {
            this.changePeriodSelectionMenuVisibility()
            this.$emit('changePeriod', period)
        },
        generatePDFExport: function () {
            const fileName = `Extrato - ${this.getSummaryDate[0].value} a ${this.getSummaryDate[1].value}`
            const css = [
                {
                    elClass: 'title',
                    value: 'display: block;position: relative;color: orange;border-bottom: solid 2px orange;margin: 0;padding: 15px; font-size: 18px'
                },
                {
                    elClass: 'h1',
                    value: 'font-size: 25px'
                },
                {
                    elClass: 'list-field',
                    value: 'display: inline-block; width: 33%; text-align: center; font-weight: bold; font-size: 18px'
                },
                {
                    elClass: 'list-item',
                    value: 'margin: 10px 0'
                },
                {
                    elClass: 'list-item-field',
                    value: 'display: inline-block; width: 33%; text-align: center; font-size: 18px'
                }
            ]
            pdfExport({ id: 'allExtractData', fileName, css })
        }
    },
    mounted () {}
}
</script>

<style lang="less" scoped>
.extract-container{
    height: calc(100vh - 215px);
    .actions {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
    }

    .period {
        display: flex;
        justify-content: space-between;
        align-items: center;

        border: 1px solid var(--cardBorder);
        box-shadow: 2px 2px 4px var(--cardBorder);
        border-radius: 50px;
        box-sizing: border-box;
        padding: 5px 10px;
        border-radius: 5px;

        h1 {
            font-weight: 600;
            padding-right: 10px;
        }
        i {
            padding-bottom: 4px;
        }
    }

    .export {
        display: flex;
        align-items: center;
        border: 1px solid var(--cardBorder);
        box-shadow: 2px 2px 4px var(--cardBorder);
        border-radius: 50px;
        box-sizing: border-box;
        padding: 5px 10px;
        border-radius: 5px;

        i {
            padding-bottom: 4px;
        }
    }

    .search {
        display: flex;
        align-items: center;
        // grey background
        background-color: #d9d9d963;
        border-radius: 5px;
        box-sizing: border-box;
        padding: 10px 10px;
        position: relative;

        input {
            border: none;
            outline: none;
            background-color: transparent;
            font-size: 18px;
            font-family: Gellix;
            width: 100%;
        }

        i {
            position: absolute;
            right: 10px;
            color: gray;
        }
    }

    .list-fields {
        display: grid;
        grid-template-columns: 55% 22% 22%;
        margin-top: 20px;
        h1 {
            margin-bottom: 10px;
            font-weight: 600;
        }
    }

    #allExtractData {
        // altura até o fim da tela
        height: calc(100% - 50px);
        overflow-y: scroll;
    }
    .list {
        padding: 0 4px;

        .title, .list-fields {
            position: sticky;
            background: var(--backgroundColor);
            top: -5px;
            padding: 5px 0;
        }
        .list-fields {
            top: 20px;
        }

        h2 {
            margin-top: 20px;
            color: var(--iconColor);
            font-weight: bold;
        }

        .list-item {
            display: grid;
            grid-template-columns: 55% 22% 22%;
            // gap: 20px;
            margin: 10px 0px;
            padding: 20px 5px;
            border: 1px solid var(--cardBorder);
            box-shadow: 2px 2px 4px var(--cardBorder);
            background: var(--cardBackground);

            .list-item-field {
                word-break: break-word;

                span {
                    font-size: 16px;
                }

                .tValue {
                    font-weight: 600;
                    text-align: right;
                    &.positive{
                        color: darkgreen;
                    }
                    &.negative {
                        color: rgb(117, 1, 1);
                    }
                }

                .tBalance {
                    text-align: right;
                }
            }

            .list-item-field .tBalance{
                margin: 0 0 0 auto;
            }
        }
    }

    .not-found {
        text-align: center;
        margin-top: 40px;
        font-weight: 600;
    }

}

.list-fields, .list-item {
    .list-field, .list-item-field  {
        font-size: .9rem;
        &:nth-of-type(2), &:nth-of-type(3) {
            text-align: right;
        }
        &:nth-of-type(2){
            text-align: center;
        }
    }
}

</style>
